import { render } from "./ChinaJingPingPage.vue?vue&type=template&id=6ebebfb8&scoped=true"
import script from "./ChinaJingPingPage.vue?vue&type=script&lang=js"
export * from "./ChinaJingPingPage.vue?vue&type=script&lang=js"

import "./ChinaJingPingPage.vue?vue&type=style&index=0&id=6ebebfb8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ebebfb8"]])

export default __exports__